export default "__VITE_ASSET__Ci8bwm_x__"